import { useState } from 'react';

interface LazyImageProps {
    className?: string;
    alt?: string;
    height?: number;
    src: string;
}

export const LazyImage: React.FC<LazyImageProps> = ({className = "", alt="image", height="auto", ...props }) => {
    const [loading, setLoading] = useState(true);

    return (
        <>
            {
                loading && <div className="relative w-full p-0 m-0 rounded darkerGray skeleton" style={{ height: height || 'auto' }}></div>
            }
           <img
                {...props}
                alt={alt}
                className={`rounded object-cover m-0 p-0 ${className} ${loading ? "hidden" : ""}`}
                onLoad={() => setLoading(false)}
            />
        </>
    )
}

